/* Ascendia — Tabby "pay in 4" promo line.
   The public key comes from Theme settings → Tabby (window.ASC_TABBY set in layout/theme.liquid).
   Renders every [data-tabby-promo] element, follows variant changes on product pages,
   and re-renders after the cart drawer / cart page replace their HTML. */
(function () {
  'use strict';
  var cfg = window.ASC_TABBY || {};
  if (!cfg.key) return;

  var pending = [];
  var loading = false;
  var counter = 0;

  function withTabby(fn) {
    if (window.TabbyPromo) { fn(); return; }
    pending.push(fn);
    if (loading) return;
    loading = true;
    var s = document.createElement('script');
    s.src = 'https://checkout.tabby.ai/tabby-promo.js';
    s.async = true;
    s.onload = function () {
      var queue = pending.splice(0);
      queue.forEach(function (f) { try { f(); } catch (e) { /* ignore */ } });
    };
    s.onerror = function () { loading = false; };
    document.head.appendChild(s);
  }

  function priceForProduct(el) {
    var map = el.getAttribute('data-tabby-variants');
    if (!map) return null;
    var formId = el.getAttribute('data-tabby-form');
    var input = null;
    if (formId) {
      var form = document.getElementById(formId);
      if (form) input = form.querySelector('[name="id"]');
      if (!input) input = document.querySelector('[form="' + formId + '"][name="id"]');
    }
    if (!input) input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!input || !input.value) return null;
    try {
      var prices = JSON.parse('{' + map + '}');
      var p = prices[String(input.value)];
      return typeof p === 'number' ? p : null;
    } catch (e) { return null; }
  }

  function render(el) {
    if (!el.isConnected) return;
    var price = parseFloat(el.getAttribute('data-tabby-price'));
    if (el.getAttribute('data-tabby-source') === 'product') {
      var live = priceForProduct(el);
      if (live !== null) price = live;
    }
    if (!(price > 0)) { el.innerHTML = ''; el.removeAttribute('data-tabby-done'); return; }
    var currency = el.getAttribute('data-tabby-currency') || 'AED';
    var lang = (el.getAttribute('data-tabby-lang') || 'en').slice(0, 2);
    var sig = [price, currency, lang].join('|');
    if (el.getAttribute('data-tabby-done') === sig) return;
    el.setAttribute('data-tabby-done', sig);
    if (!el.id) el.id = 'asc-tabby-' + (++counter);
    el.innerHTML = '';
    try {
      new window.TabbyPromo({
        selector: '#' + el.id,
        currency: currency,
        price: price,
        lang: lang,
        source: el.getAttribute('data-tabby-source') || 'product',
        productType: 'installments', // pay-in-4 only; hides Tabby's monthly-plan "As low as" line
        publicKey: cfg.key,
        merchantCode: cfg.merchant || 'default'
      });
    } catch (e) {
      el.removeAttribute('data-tabby-done');
    }
  }

  var timer = null;
  function renderAll() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      var els = document.querySelectorAll('[data-tabby-promo]');
      if (!els.length) return;
      withTabby(function () { els.forEach(render); });
    }, 80);
  }

  function start() {
    renderAll();
    // Variant change (Dawn dispatches a bubbling "change" on the hidden variant input).
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && (t.name === 'id' || t.closest('variant-radios, variant-selects, variant-picker'))) renderAll();
    }, true);
    // Cart drawer / cart page / price block replaced via innerHTML.
    var mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && (n.matches('[data-tabby-promo]') || n.querySelector('[data-tabby-promo]'))) { renderAll(); return; }
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', renderAll);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
